import { gsap } from "gsap"
import { ExpoScaleEase } from "gsap/EasePack"
import { ScrollTrigger } from "gsap/ScrollTrigger"

export const load = function () {

  gsap.registerPlugin(ExpoScaleEase, ScrollTrigger)

  ScrollTrigger.create({
    start: "top -120",
    end: 99999,
    toggleClass: {
      className: "not-top",
      targets: [".site-header", ".mobile-nav"]
    }
  })

  ScrollTrigger.batch(".stepped-fade-in", {
    interval: 0.25, // time window (in seconds) for batching to occur.
    once: true,
    start: "50px bottom",
    onEnter: batch => {
      gsap.to(batch, {
          opacity: 1,
          duration: .25,
          stagger: .25
      })
    }
  })

  let logoSwooshPath = document.querySelector("#SwooshMaskPath")
  let logoSwoosh = document.querySelector("#LogoSwoosh")
  let logoBackground = document.querySelector("#LogoMarkBackground")
  let logoForeground = document.querySelector("#LogoMarkForeground")
  let logoText = document.querySelector(".logo-text")

  let logoMarkTimeline = gsap.timeline({ duration: .5, ease: "power2" })

  logoMarkTimeline.to(logoBackground, {
    height: "42px",
    opacity: 1
  })
  logoMarkTimeline.to(logoSwoosh, {
    opacity: 1
  })
  logoMarkTimeline.to(logoSwooshPath, {
    width: "44px"
  }, "<")
  logoMarkTimeline.to(logoForeground, {
    opacity: 1
  })
  logoMarkTimeline.to(logoText, {
    opacity: 1
  })

  gsap.to(".main-nav-item", { opacity: 100, duration: .5, delay: 2, stagger: .5 })

  gsap.to(".hero-bg", {
    yPercent: 25,
    scrollTrigger: {
      trigger: ".hero",
      // start: "top bottom", // the default values
      // end: "bottom top",
      scrub: true
    }
  })

  gsap.fromTo(
    ".hero-bg-image",
    {
      opacity: 0
    },
    {
      opacity: 1,
      ease: "power4",
      duration: 5,
      delay: 2.5
    }
  )

  const createParallax = () => {

    if (window.innerWidth < 768) {
        return
    }

    console.log('Started parallax')

    gsap.utils.toArray(".parallax-section-circles").forEach(container => {
      let tl = gsap.timeline()

      tl.to(container.querySelector(".parallax-offset-cirlces"), {
        yPercent: 35,
        // ease: "power4",
        scrollTrigger: {
          trigger: container,
          start: "top bottom", // the default values
          end: "bottom top",
          scrub: true
        }
      })
    })

    gsap.utils.toArray(".parallax-section").forEach(container => {
      let tl = gsap.timeline()

      tl.to(container.querySelector(".parallax-offset-35"), {
        yPercent: 35,
        // ease: "power4",
        scrollTrigger: {
          trigger: container,
          start: "top bottom", // the default values
          end: "bottom top",
          scrub: true
        }
      })
    })

    gsap.utils.toArray(".parallax-section").forEach(container => {
      let tl = gsap.timeline()

      tl.to(container.querySelector(".parallax-offset-reverse-35"), {
        yPercent: -35,
        // ease: "power4",
        scrollTrigger: {
          trigger: container,
          start: "top bottom", // the default values
          end: "bottom top",
          scrub: true
        }
      })
    })

    gsap.utils.toArray(".parallax-section").forEach(container => {
      let tl = gsap.timeline()

      tl.to(container.querySelector(".parallax-offset-25"), {
        yPercent: 25,
        // ease: "power4",
        scrollTrigger: {
          trigger: container,
          start: "top bottom", // the default values
          end: "bottom top",
          scrub: true
        }
      })
    })

    gsap.utils.toArray(".parallax-section").forEach(container => {
      let tl = gsap.timeline()

      tl.to(container.querySelector(".parallax-offset-reverse-25"), {
        yPercent: -25,
        // ease: "power4",
        scrollTrigger: {
          trigger: container,
          start: "top bottom", // the default values
          end: "bottom top",
          scrub: true
        }
      })
    })

    gsap.utils.toArray(".parallax-section").forEach(container => {
      let tl = gsap.timeline()

      tl.to(container.querySelector(".parallax-offset-10"), {
        yPercent: 10,
        // ease: "power4",
        scrollTrigger: {
          trigger: container,
          start: "top bottom", // the default values
          end: "bottom top",
          scrub: true
        }
      })
    })

    gsap.utils.toArray(".parallax-section").forEach(container => {
      let tl = gsap.timeline()

      tl.to(container.querySelector(".parallax-offset-reverse-10"), {
        yPercent: -10,
        // ease: "power4",
        scrollTrigger: {
          trigger: container,
          start: "top bottom", // the default values
          end: "bottom top",
          scrub: true
        }
      })
    })
  }

  createParallax()
  window.addEventListener("resize", createParallax)

  gsap.utils.toArray(".project-card").forEach(container => {
      let tl = gsap.timeline({ paused: true, duration: .25, ease: "power2" })
      const textBox = container.querySelector(".project-card-textbox")

      tl.fromTo(
          container.querySelector(".project-card-label"),
          { yPercent: 100, opacity: 0 },
          { yPercent: 0, opacity: 1 },
          "<"
      ).fromTo(
          container.querySelector(".project-card-link"),
          { yPercent: -100, opacity: 0 },
          { yPercent: 0, opacity: 1 },
          "<"
      ).fromTo(
          container.querySelector(".project-card-overlay"),
          { opacity: .20 },
          { opacity: .35 },
          "<"
      )

      textBox.addEventListener("mouseenter", () => tl.play())
      textBox.addEventListener("mouseleave", () => tl.reverse())
  })
}